export class TypedEvent extends CustomEvent {
    get type() {
        return this._type;
    }
    constructor(type, value) {
        super(typeof type === 'string' ? type : type.type, {
            detail: value,
            bubbles: true,
            composed: true,
        });
        this._type = '';
    }
}
/**
 * Defined a typed event. Make sure to use currying and call this function twice! Typescript's
 * generic restrictions require this setup to get the types right without excessive verbosity.
 *
 * Example: const myCustomEvent = defineTypedEvent<number>()('my-custom-event')
 */
export function defineTypedEvent() {
    return (eventType) => {
        var _a;
        return _a = class extends TypedEvent {
                constructor(value) {
                    super(eventType, value);
                    this._type = eventType;
                }
            },
            _a.type = eventType,
            _a;
    };
}
